export const mapCityDetailResponse = cityDetails => ({
    id: cityDetails.id,
    legacyId: cityDetails.legacy_id,
    name: cityDetails.name,
    countryCode: cityDetails.country_code.toUpperCase(),
    timezoneOffset: cityDetails.timezone_offset,
});
